import { ReactNode } from 'react';
import { ActivableRenderer, ActivableRendererProps, Portal } from '@optimus-web/helpers';
import { SideMenuPanelContainer, SideMenuPanelContent } from './style';

export interface SideMenuPanelProps extends ActivableRendererProps {
    children?: ReactNode;
    active?: boolean;
    portalContainerId?: string;
    collapsed?: boolean;
}

const SideMenuPanelActivatorFunction = ActivableRenderer<React.Component<SideMenuPanelProps>, SideMenuPanelProps>({
    activePropName: 'active',
});

const SideMenuPanelComponent = ({
    active,
    children,
    portalContainerId = 'sideMenuContainer',
    collapsed,
}: SideMenuPanelProps) => (
    <Portal containerId={portalContainerId}>
        <SideMenuPanelContainer active={active} collapsed={collapsed}>
            <SideMenuPanelContent>{children}</SideMenuPanelContent>
        </SideMenuPanelContainer>
    </Portal>
);

export const SideMenuPanel = SideMenuPanelActivatorFunction(SideMenuPanelComponent);
